module.exports = __webpack_public_path__ + "img/ps-41.363ad9a3.jpg";